import { render, staticRenderFns } from "./NodeDetailsModal.vue?vue&type=template&id=796c11a9"
import script from "./NodeDetailsModal.vue?vue&type=script&lang=js"
export * from "./NodeDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports